module.exports = __webpack_public_path__ + "img/mirror33.b1f27b52.jpg";